<template>
  <div class="tdic">
    <PinchInImg v-show="showPinchIn"/>
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">

        <div id="toparea" class="toparea-text flexcenter" :style="toparea_visible">
          <template v-if="isEnvironmentPc()">
            <textarea readOnly id="inputtext" class="input item font24 cancelEnter" style="color:#000000; overflow:hidden;" placeholder="英文を入力してください"></textarea>
            <div id="okbutton" class="icon-ok" @click="setAnswer"></div>
            <div id="ssbutton" class="icon-skip" @click="skipQuestion"></div>
            <p id="answer_string" class="font24 answer"></p>
          </template>
        </div>

        <template v-if="isEnvironmentPc()">
          <div class="cards-container active-type2 card-voice">

            <template v-for="(actblock, index) in acts">
              <div :class="actblock[0].layoutClass" :key="index">

                <template v-for="(act, index2) in actblock">
                  <div :id="act.active_id" :class="act.active" :name="act.sound" :key="index2">
                    <p :id="act.text_id" v-html="getText(act)"/>
                    <div class="card">
                      <div class="image"><img v-bind:src="act.image"></div>
                      <button :id="act.sbutton_id" class="icon-voice" :style="act.sbutton_visible"></button>
                      <div :id="act.correct_id"></div>
                    </div>
                  </div>
                </template>

              </div>
            </template>

          </div>
        </template>
        <template v-else>
          <div class="cards-container swiper-container swiper-container1 active-type2 card-voice">
            <div class="swiper-wrapper">

              <template v-for="(actblock, index) in acts">
                <div :class="actblock[0].layoutClass" :key="index">
                  <div class="swiper-container swiper-container2">
                    <div class="swiper-wrapper">

                      <template v-for="(act, index2) in actblock">
                        <div :id="act.active_id" :class="act.active" :name="act.sound" :key="index2">
                          <div class="textarea-wrap" v-show="currentActIndex == getTargetActTypeTyping(index, index2) && isShowTextArea(pathstep.acts[currentActIndex])" :style="placeholderStyles">
                            <textarea :id="act.inputtext_id" class="cancelEnter" placeholder="英文を入力してください"></textarea>
                            <p :id="act.answer_string_id" class="answer" style="visibility: hidden"></p>
                            <div class="icon-wrap">
                              <div :id="act.okbutton_id" class="icon-ok" @click="setAnswer"></div>
                              <div :id="act.ssbutton_id" class="icon-skip" @click="skipQuestion"></div>
                            </div>
                          </div>
                          <p v-show="currentActIndex != getTargetActTypeTyping(index, index2) || !isShowTextArea(pathstep.acts[currentActIndex])" :id="act.text_id" v-html="getText(act)" />
                          <div class="card">
                            <div class="image" @touchstart="onTouchStart(act.image)"
                              @touchend="onTouchEnd()" @touchmove="onTouchEnd()"><img v-bind:src="act.image"></div>
                            <button :id="act.sbutton_id" class="icon-voice" :style="act.sbutton_visible"></button>
                            <div :id="act.correct_id" ></div>
                          </div>
                        </div>
                      </template>

                    </div>
                  </div>
                </div>
              </template>

            </div>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import tdic from "@/mixin/tdic";
import * as commonLayout from "@/mixin/TLayout";
import * as constants from "@/store/constants";
import * as mixinConstants from "@/mixin/constants";

var lodash = require("lodash");

// 画像拡大モーダルコンポーネント
import PinchInImg from "./PinchInImg";

var step;
var sub_step;
var key_enter = "✔︎ x";
var key_backspace = "bs";
var skipFlag;

export default {
  name: "TDic",
  props: [
    "pathstepIndex",
    "pathstep"
  ],
  mixins: [
    common,
    runmode,
    tdic
  ],
  data() {
    return {
      nowInput: false,
      soundPlay: true,
      soundPlaying: false,
      inputString: "",
      specialKey: "",
      // 不正解時true
      badFlag: false,
      pause_flag: false,
      exitFlag: false,
      jtext: "",
      jsondata: "",
      backDisabled: true,
      goDisabled: true,
      layoutID: -1,
      // 正解ステータスカウント用
      correctIndex: [],
      // 不正解ステータスカウント用
      incorrectIndex: [],
      r_timer: null,
      toparea_visible: "visibility:visible;",
      startFlag: false,
      startCheckFlag: false,
      stopFlag: false,
      layoutClassPointer: -1,
      layoutClassCount: 0,
      acts: [],
      currentActIndex: 0,
      // タッチイベント長押しタイマー
      touchTimer: null
    };
  },
  components: {
    PinchInImg
  },
  watch: {
    // ツールバー「日本語翻訳を表示する」の選択状態を監視する
    dispJapaneseStatus: function(newstatus) {
      this.log("TDic watch dispJapaneseStatus");
      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.applyTypingCardAreaSize();
          this.changeunDisp();
        }
      } else {
        this.applyTypingCardAreaSize();
        this.changeDispJapanese();
      }
    },
    // ツールバー「全解答を表示する」の選択状態を監視する
    dispAllAnswerStatus: function(newstatus) {
      this.log("TDic watch dispAllAnswerStatus");
      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.applyTypingCardAreaSize();
          this.changeunDisp();
        }
      } else {
        this.applyTypingCardAreaSize();
        this.changeDispAnswer();
      }
    },
    lessonState: function(state) {
      this.log("-------- TDic::lessonState :" + state + ":" + constants.LESSON_STATE_START);
      // ステータス処理
      if (state == constants.LESSON_STATE_STOP) {
        this.stopFlag = true;
      } else if (state == constants.LESSON_STATE_PAUSE) {
        // レッスン停止
        this.lessonPause();
      } else if (state == constants.LESSON_STATE_RESTART) {
        // レッスンリスタート
        this.lessonRestart();
      } else if (state == constants.LESSON_STATE_START) {
        this.log("----- start question!! -----");
        this.startFlag = true;
        this.startCheckFlag = true;
      }
      // 表示領域自動調整
      this.autoAdjustFirstShownTyping();
    }
  },
  methods: {
    lessonPause: function() {
      this.log("------ lesson pause -------");
      this.pause();
    },
    lessonRestart: function() {
      this.log("------ lesson restart ------");
      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.resume();
        }
      }
    },
    changeunDisp: function() {
      this.log("-------- cancel answer display");
      for (var i = 0; i < this.jsondata["acts"].length; i++) {
        this.jsondata["acts"][i]["text"] = this.jsondata["acts"][i]["text0"];
        var elem = document.getElementById("text" + i);
        elem.innerHTML = this.jsondata["acts"][i]["text"];
        this.log(this.jsondata["acts"][i]["text"]);
      }
      this.resume();
    },
    changeDispJapanese: function() {
      this.log("-------- japanese display");
      for (var i = 0; i < this.jsondata["acts"].length; i++) {
        this.jsondata["acts"][i]["text"] = "<SPAN>" + this.jsondata["acts"][i]["japaneseText"] + "</SPAN>";
        var elem = document.getElementById("text" + i);
        if (this.isEnvironmentPc()) {
          this.checkSetTargetFontClassTypeTyping(elem, this.jsondata["acts"][i]["text"]);
        }
        elem.innerHTML = this.jsondata["acts"][i]["text"];
        this.log(this.jsondata["acts"][i]["text"]);
      }
      // モバイル版はtopareaを非表示にしない（レイアウトが崩れるため）
      if (this.isEnvironmentPc()) {
        this.toparea_visible = "visibility:hidden;";
      }
      this.pause();
    },
    changeDispAnswer: function() {
      this.log("------- all answer display");
      for (var i = 0; i < this.jsondata["acts"].length; i++) {
        this.jsondata["acts"][i]["text"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][i]["basicText"]) + "</SPAN>";
        var elem = document.getElementById("text" + i);
        if (this.isEnvironmentPc()) {
          this.checkSetTargetFontClassTypeTyping(elem, this.jsondata["acts"][i]["text"]);
        }
        elem.innerHTML = this.jsondata["acts"][i]["text"];
        this.log(this.jsondata["acts"][i]["text"]);
      }
      // モバイル版はtopareaを非表示にしない（レイアウトが崩れるため）
      if (this.isEnvironmentPc()) {
        this.toparea_visible = "visibility:hidden;";
      }
      this.pause();
    },
    pause: function() {
      this.log("------ pause ------");
      if (this.audioPlaying === true && this.myAudio != null) {
        // 音声停止
        this.myAudio.pause();
        // 音声再生中フラグ変更
        this.audioPlaying = false;
      }
      var elem = this.getInputTextElement();
      this.log("input::" + elem.value);
      this.inputString = elem.value;
      this.sbuttonActive();
      this.pause_flag = true;
    },
    getText: function(act) {
      return act.text;
    },
    resume: function() {
      this.log("------ resume ------");
      // ◯×を消す
      var elem = document.getElementById("correct_id" + step);
      if (elem != undefined) {
        elem.className = "";
      }
      if (sub_step == 2) {
        this.nextQuestion();
      } else if (sub_step != 1) {
        sub_step = 0;
      }
      this.sbuttonActive(true);
      this.toparea_visible = "visibility:visible;";
      this.soundPlaying = true;
      this.audioPlaying = false;
      this.pause_flag = false;
    },
    getObjectSize: function(obj) {
      var a = obj.length;
      if (a === undefined) {
        a = 1;
      }
      return a;
    },
    // スライドさせる
    slide: function(num) {
      if (this.isEnvironmentPc()) {
        return;
      }
      var max = this.jsondata["acts"].length;
      if (num >= max) {
        return;
      }
      var cnt = this.getObjectSize(this.swiperIn);
      if (cnt === 1) {
        this.swiperIn.slideTo(num);
      } else {
        var off = 0;
        while (off < cnt && this.getObjectSize(this.acts[off]) <= num) {
          num -= this.getObjectSize(this.acts[off]);
          off++;
        }
        this.swiperOut.slideTo(off);
        this.swiperIn[off].slideTo(num);
      }
    },
    getSwipeWrapper: function() {
      var str = "swiper-wrapper ";
      if (this.isEnvironmentPc()) {
        str = "";
      }
      return str;
    },
    getSwiperSlide: function() {
      var str = "swiper-slide ";
      if (this.isEnvironmentPc()) {
        str = "";
      }
      return str;
    },
    setCards: function() {
      this.jsondata = this.pathstep;
      this.log("--- json --- :" + this.jsondata);
      var max = this.jsondata["acts"].length;
      this.log("count:" + max);
      this.layoutID = this.jsondata["layoutID"];
      this.log("layoutID::" + this.layoutID);
      var i;
      for (i = 0; i < max; i++) {
        // レイアウト用クラスの設定
        this.jsondata["acts"][i]["layoutClass"] = "";
        if (this.layoutClassCount == 0) {
          var id = 0;
          for (var j = 0; j < commonLayout.layoutClassTable.length; j++) {
            if (commonLayout.layoutClassTable[j][0] == this.layoutID) {
              id = j;
              break;
            }
          }
          this.layoutClassPointer++;
          this.acts[this.layoutClassPointer] = Array();
          this.jsondata["acts"][i]["layoutClass"] = "card-inner " + this.getSwiperSlide() + commonLayout.layoutClassTable[id][this.layoutClassPointer + 1][0];
          this.layoutClassCount = commonLayout.layoutClassTable[id][this.layoutClassPointer + 1][1];
          this.log(i + "::layoutClass=" + this.jsondata["acts"][i]["layoutClass"]);
        }
        this.layoutClassCount--;
        // 要素の設定
        this.jtext = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][i]["basicText"]) + "</SPAN>";
        this.log("actimage=" + this.jsondata["acts"][i]["image"] + " jtext=" + this.jtext);
        this.jsondata["acts"][i]["text_id"] = "text" + i;
        this.jsondata["acts"][i]["sbutton_id"] = "sbutton" + i;
        this.jsondata["acts"][i]["correct_id"] = "correct_id" + i;
        this.jsondata["acts"][i]["active_id"] = "active" + i;
        this.jsondata["acts"][i]["sbutton"] = "sbutton" + i;
        this.jsondata["acts"][i]["inputtext_id"] = "inputtext" + i;
        this.jsondata["acts"][i]["okbutton_id"] = "okbutton" + i;
        this.jsondata["acts"][i]["ssbutton_id"] = "ssbutton" + i;
        this.jsondata["acts"][i]["answer_string_id"] = "answer_string" + i;
        if (this.jsondata["acts"][i]["challenge"] === 0) {
          this.jsondata["acts"][i]["active"] = "item " + this.getSwiperSlide() + "given disabled";
        } else {
          if (this.isEnvironmentPc()) {
            this.jsondata["acts"][i]["active"] = "item " + this.getSwiperSlide() + "challenge-gray disabled";
          } else {
            this.jsondata["acts"][i]["active"] = "item " + this.getSwiperSlide() + "challenge-white disabled";
          }
        }
        this.jsondata["acts"][i]["text"] = "";
        this.jsondata["acts"][i]["text0"] = "";
        if (this.jsondata["acts"][i]["challenge"] === 0) {
          this.jsondata["acts"][i]["text"] = this.jtext;
          this.jsondata["acts"][i]["text0"] = this.jtext;
        }
        this.acts[this.layoutClassPointer].push(this.jsondata["acts"][i]);
      }
      this.log("this.acts=" + this.acts);
    },
    setCards2: function() {
      var i;
      const self = this;
      var max = this.jsondata["acts"].length;
      for (i = 0; i < max; i++) {
        var elem2 = document.getElementById("active" + i);
        this.log("active" + i + "::" + elem2);
        elem2.onclick = function(e) {
          var n;
          var target = e.target;
          while (target.id.substr(0, 6) != "active") {
            target = target.parentNode;
          }
          self.log("className=" + target.className);
          if (target.className != "item swiper-slide disabled") {
            n = target.id.substr(6, 1);
            self.log(" sbutton" + n);
            // モバイル版は出題中のActはカード押下時の音声再生不可（テキスト入力を可能とするため）
            if ((self.currentActIndex != n && !self.isEnvironmentPc()) || self.isEnvironmentPc()) {
              var elem = document.getElementById("sbutton" + n);
              elem.name = self.jsondata["acts"][n]["sounds"][0];
              if (elem.className !== "icon-voice disabled") {
                // 音声再生時に入力内容がクリアされてしまう不具合の対応
                var elem_t = self.getInputTextElement();
                self.inputString = elem_t.value;
                self.log("play soound!!" + elem.name);
                self.sbuttonActive(false);
                self.autoPlay(elem.name, 10);
                self.soundPlay = true;
                self.soundPlaying = false;
              }
            }
          }
        };
        var elem = document.getElementById("sbutton" + i);
        elem.className = "icon-voice disabled";
        elem.name = this.jsondata["acts"][i]["sounds"][0];
        elem.onclick = function(e) {
          if (e.target.className !== "icon-voice disabled") {
            var n = e.target.id.substr(7, 1);
            self.log("play soound!!" + e.target.name);
            var elem = self.getInputTextElement();
            self.inputString = elem.value;
            self.sbuttonActive(false);
            self.autoPlay(e.target.name, 10);
            self.soundPlay = true;
            self.soundPlaying = false;
          }
        };
      }
      this.r_timer = setTimeout(this.timerTick, 100);
      self.sbuttonActive(false);
      elem = self.getAnswerStringElement();
      self.log("p::" + elem);
      elem.innerHTML = "";
      elem.style.cssText = "visibility:hidden;";
      // エンターキーのキャンセル
      $(".cancelEnter").bind("keydown", function(e) {
        if (e.which == 13) {
          self.log("press enter!! badFlag=" + self.badFlag);
          if (self.badFlag === false && self.pause_flag === false) {
            elem = self.getInputTextElement();
            self.inputString = elem.value;
            self.specialKey = key_enter;
          }
          return false;
        }
      }).bind("blur", function() {
        if (self.badFlag === false) {
          // 貼りつけられたテキストの改行コードを削除
          var $textarea = $(this),
            text = $textarea.val(),
            new_text = text.replace(/\n/g, "");
          if (new_text != text) {
            $textarea.val(new_text);
          }
        }
      });
      if (!this.isEnvironmentPc()) {
        this.sliderInit();
      }
    },
    // 初期化
    init: function() {
      if (this.$store.getters.lessonState == constants.LESSON_STATE_START) {
        this.startFlag = true;
        this.startCheckFlag = true;
      }
      step = 0;
      sub_step = 0;
      this.setCards();
      this.audioPlaying = false;
      this.backDisabled = false;
      this.goDisabled = false;
      if (document.addEventListener) {
        // キーボードを押したときに実行されるイベント
        document.addEventListener("keydown", this.keyDownFunc);
      }
    },
    setActive: function() {
      var elem;
      this.log("setActive step=" + step);
      var max = this.jsondata["acts"].length;
      if (step < max) {
        // 次の問題をアクティブに
        elem = document.getElementById("active" + step);
        this.log("active:" + elem);
        if (this.jsondata["acts"][step]["challenge"] == 0) {
          elem.className = "item " + this.getSwiperSlide() + "given active";
        } else {
          if (this.isEnvironmentPc()) {
            elem.className = "item " + this.getSwiperSlide() + "challenge-gray active";
          } else {
            elem.className = "item " + this.getSwiperSlide() + "challenge-white active";
          }
        }
      }
      // 前の問題を非アクティブに
      if (step > 0) {
        elem = document.getElementById("active" + (step - 1));
        this.log("not active:" + elem);
        if (elem != null) {
          elem.className = "item " + this.getSwiperSlide() + "challenge-white";
        }
      }
      // 入力エリアをクリア
      elem = this.getInputTextElement();
      this.inputString = "";
      elem.value = "";
      if (step != max) {
        elem.focus();
      }
      this.log("setActive end!!");
    },
    // キーダウンイベント
    keyDownFunc: function(e) {
      var elem;
      this.log("key down!!");
      if (e.keyCode === 37 || e.keyCode === 39) {
        return;
      }
      elem = this.getInputTextElement();
      var text = elem.value;
      if (e.keyCode === 13) {
        this.log("enter key down!!");
        if (this.badFlag === false) {
          elem = this.getInputTextElement();
          this.inputString = elem.value;
          this.specialKey = key_enter;
        }
      }
    },
    setInputArea() {
      this.log("setInputArea");
      var elem = this.getAnswerStringElement();
      this.log("p::" + elem);
      elem.innerHTML = "";
      elem.style.cssText = "visibility:hidden;";
      elem = this.getInputTextElement();
      elem.style.color = "#000000";
      elem.value = this.inputString;
      elem.placeholder = "英文を入力してください";
      this.log("------- textarea::" + elem + " ------");
      elem.readOnly = false;
      elem.focus();
      this.badFlag = false;
    },
    sbuttonActive: function(state) {
      this.log("sbuttonActive " + state);
      var max = this.jsondata["acts"].length;
      if (this.pause_flag == false) {
        var elem = this.getSkipButtonElement();
        if (state == true) {
          elem.className = "icon-skip";
        } else {
          elem.className = "icon-skip disabled";
        }
      }
      var elem = this.getOkButtonElement();
      var elem2 = this.getInputTextElement();
      if (state == true && this.pause_flag === false) {
        this.log("------ OK BUTTON AVTICE!!");
        elem.className = "icon-ok";
        elem2.readOnly = false;
      } else {
        this.log("------ OK BUTTON DISABLED!!");
        elem.className = "icon-ok disabled";
        elem2.readOnly = true;
      }
      for (var i = 0; i < max; i++) {
        elem = document.getElementById("sbutton" + i);
        if (state == false) {
          elem.className = "icon-voice disabled";
        } else if (i <= step && elem != undefined) {
          if (elem.className == "icon-voice disabled") {
            elem.className = "icon-voice";
          }
        }
      }
    },
    timerTick: function() {
      this.currentActIndex = step;
      if (this.stopFlag == true) {
        this.log("********* skip ********");
        if (this.timer != null) {
          clearTimeout(this.timer);
        }
        if (this.audioPlaying === true && this.myAudio != null) {
          // 音声停止
          this.myAudio.pause();
          this.audioPlaying = false;
        }
        this.log("stop act");
        this.$emit("stopAct");
        return;
      }
      if (this.startFlag == false) {
        this.r_timer = setTimeout(this.timerTick, 10);
        return;
      }
      if (this.startCheckFlag == true) {
        // 最初の読み上げ
        this.setActive();
        this.audioPlaying = false;
        this.autoPlay(this.jsondata["acts"][0]["sounds"][0], 100);
        this.soundPlay = true;
        this.soundPlaying = false;
        this.startCheckFlag = false;
      }
      if (this.pause_flag) {
        if (this.soundPlay == true && this.audioPlaying === true) {
          this.soundPlaying = true;
        }
        if (this.soundPlaying === true && this.audioPlaying === false) {
          this.soundPlay = false;
          this.soundPlaying = false;
          this.sbuttonActive(true);
        }
        this.r_timer = setTimeout(this.timerTick, 10);
        return;
      }
      var data = this.jsondata;
      var max = data["acts"].length;
      if (skipFlag) {
        skipFlag = false;
        if (step < max) {
          this.log("********** set innerHTML");
          var elem = document.getElementById("text" + step);
          elem.innerHTML = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][step]["basicText"]) + "</SPAN>";
          this.jsondata["acts"][step]["text0"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][step]["basicText"]) + "</SPAN>";
          this.jsondata["acts"][step]["text"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][step]["basicText"]) + "</SPAN>";
        }
        this.nextQuestion();
      } else {
        if (this.soundPlay == true && this.audioPlaying === true) {
          this.soundPlaying = true;
        }
        if (this.soundPlaying === true && this.audioPlaying === false) {
          this.log("sound end!! sub_step=" + sub_step);
          this.soundPlay = false;
          this.soundPlaying = false;
          this.sbuttonActive(true);
          // ◯×を消す
          var elem = document.getElementById("correct_id" + step);
          this.log("delete collect:" + elem + " step=" + step + " sub_step=" + sub_step);
          elem.className = "";
          if (data["acts"][step]["challenge"] == true && sub_step === 1) {
            this.log("------ check!! sub_step=" + sub_step);
            this.log("------ inputString=" + this.inputString);
            this.setInputArea();
          }
          if (data["acts"][step]["challenge"] == false) {
            step++;
            this.slide(step);
            this.setActive();
            if (step >= max) {
              this.sbuttonActive(false);
              this.currentActIndex = -1;
              setTimeout(this.nextQuestionCallback, mixinConstants.ALLCORRECT_INTERVAL);
              return;
            } else {
              this.sbuttonActive(false);
              this.autoPlay(data["acts"][step]["sounds"][0], 1000);
              this.soundPlay = true;
              this.soundPlaying = false;
            }
          } else {
            if (sub_step === 0) {
              this.log("---- sub_step=0 -----");
              this.inputString = "";
              this.setInputArea();
              this.nowInput = true;
              sub_step++;
            } else if (sub_step === 2) {
              this.log("next question!!");
              this.nowInput = false;
              this.soundPlaying = false;
              step++;
              this.slide(step);
              sub_step = 0;
              this.setActive();
              if (step >= max) {
                this.currentActIndex = -1;
                setTimeout(this.nextQuestionCallback, mixinConstants.ALLCORRECT_INTERVAL);
                return;
              } else {
                this.sbuttonActive(false);
                this.autoPlay(data["acts"][step]["sounds"][0], 1000);
                this.soundPlay = true;
                this.soundPlaying = false;
              }
            }
          }
        }
        if (step < max) {
          if (data["acts"][step]["challenge"] == true && sub_step === 1 && this.badFlag === false) {
            if (this.specialKey === key_enter) {
              // エンターキー
              this.specialKey = "";
              if (this.checkAnswer()) {
                // 正解
                this.log('correct answer');
                sub_step++;
              } else {
                this.badFlag = true;
              }
            } else if (this.specialKey === key_backspace) {
              this.inputString = this.inputString.substring(0, this.inputString.length - 1);
              this.specialKey = "";
            }
          }
        }
      }
      if (this.exitFlag == false) {
        this.r_timer = setTimeout(this.timerTick, 10);
      }
    },
    nextQuestionCallback: function() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.log("end act");
      this.$emit("endAct");
      this.exitFlag = true;
    },
    nextQuestion: function() {
      this.log("next question!!");
      if (this.audioPlaying === true && this.myAudio != null) {
        // 音声再生中フラグ変更
        this.audioPlaying = false;
      }
      var data = this.jsondata;
      var max = data["acts"].length;
      step++;
      this.slide(step);
      sub_step = 0;
      this.log("----- step=" + step + " max=" + max);
      if (step >= max) {
        setTimeout(this.nextQuestionCallback, 2000);
        return;
      } else {
        this.nowInput = false;
        this.setActive();
        this.sbuttonActive(false);
        this.log("--- step=" + step);
        this.log("--- sounds=" + data["acts"][step]["sounds"][0]);
        this.log("----- audio=" + this.myAudio);
        if (this.myAudio !== null) {
          this.autoPlay(data["acts"][step]["sounds"][0], 1000);
        }
        this.soundPlay = true;
        this.soundPlaying = false;
      }
    },
    // 問題のスキップ
    skipQuestion: function() {
      var elem = this.getSkipButtonElement();
      if (elem.className === "icon-skip") {
        this.log("skip!!");
        skipFlag = true;
      }
    },
    // 正解チェック
    checkAnswer: function() {
      this.log("start checkAnswer");

      var result = false;

      document.activeElement.blur();

      var data = this.pathstep;
      var answer = this.tagErase(data["acts"][step]["basicText"]).trim();

      // 正誤判定
      var check = this.checkProcess(answer, this.inputString);
      if(check.get('res')) {
        // 正解
        result = true;
      }

      // 音声停止
      if (this.myAudio != null) {
        this.myAudio.pause();
      }

      // 音声再生中フラグ変更
      this.audioPlaying = false;
      if (result) {
        // 正解
        if (this.$store.getters.answerSound == "true") {
          this.autoPlay("static/resource/sound/correct.mp3", 10);
        } else {
          this.correctDummyFunc();
        }
        this.sbuttonActive(false);
        // 正解数更新
        if (!_.includes(this.incorrectIndex, step)) {
          this.correctIndex.push(step);
          this.setActState(true);
        }
        // 前の問題の問題文エリアに回答を設定
        var elem = document.getElementById("text" + step);
        elem.innerHTML = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][step]["basicText"]) + "</SPAN>";
        this.jsondata["acts"][step]["text0"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][step]["basicText"]) + "</SPAN>";
        this.jsondata["acts"][step]["text"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][step]["basicText"]) + "</SPAN>";
        elem = document.getElementById("correct_id" + step);
        elem.className = "correct";
        var elem = this.getInputTextElement();
        elem.value = this.tagErase(this.jsondata["acts"][step]["basicText"]);
        elem.readOnly = true;
      } else {
        this.sbuttonActive(false);
        // 不正解
        if (this.$store.getters.answerSound == "true") {
          this.autoPlay("static/resource/sound/incorrect.mp3", 10);
        } else {
          this.correctDummyFunc();
        }
        // 不正解数更新
        if (!_.includes(this.incorrectIndex, step)) {
          this.incorrectIndex.push(step);
          this.setActState(false);
        }
        elem = document.getElementById("correct_id" + step);
        elem.className = "incorrect";
        const self = this;
        setTimeout(function() {
          self.makeAnswerString(check.get('answer').trim());
        }, 200);
      }

      this.soundPlay = true;
      this.soundPlaying = false;

      this.log("end checkAnswer: " + result);
      return result;
    },
    audioEnd: function() {
      this.log("--------- correct sound end dummy!!");
      this.audioPlaying = false;
      this.soundPlaying = true;
    },
    correctDummyFunc: function() {
      setTimeout(this.audioEnd, 1000);
    },
    tagErase: function(str) {
      return str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
    },
    makeAnswerString: function(inputString) {
      this.log("start makeAnswerString");

      var inputElem = this.getInputTextElement();
      inputElem.style.color = "#ffffff";
      inputElem.placeholder = "";
      inputElem.readOnly = true;

      var answerElem = this.getAnswerStringElement();
      answerElem.innerHTML = "<span>" + inputString.trim() + "</span>";

      var answerStringId = "#answer_string";
      // モバイル版はActの要素のためidにindexを付与
      if (!this.isEnvironmentPc()) {
        answerStringId += this.currentActIndex;
      }

      var rect = inputElem.getBoundingClientRect();
      if (this.isEnvironmentPc()) {
        if ($(answerStringId).innerHeight() >= 50) {
          $(answerStringId).offset({
            top: rect.top + 6,
            left: rect.left + 12
          });
          $(answerStringId).css({
            visibility: "visible"
          });
        } else {
          $(answerStringId).offset({
            top: rect.top + 12,
            left: rect.left + 12
          });
          $(answerStringId).css({
            visibility: "visible"
          });
        }
      } else {
        $(answerStringId).css({
          visibility: "visible"
        });
      }

      this.log("end makeAnswerString");
    },
    // インプットエリアがフォーカスされた時
    focusInput: function() {
      if (!this.isEnvironmentPc()) {
        $(".sp-second-header").css("display", "none");
        $(".goback").css("display", "none");
      }
    },
    // インプットエリアからフォーカスが外れた時
    blurInput: function() {
      if (!this.isEnvironmentPc()) {
        $(".sp-second-header").css("display", "block");
        $(".goback").css("display", "block");
      }
    },
    setAnswer: function() {
      this.log("ok button click!! badFlag=" + this.badFlag);
      var okElem = this.getOkButtonElement();
      if (this.badFlag === false && this.pause_flag === false && okElem.className === "icon-ok") {
        this.log("ok button click!!");
        var elem = this.getInputTextElement();
        this.log("input::" + elem.value);
        this.inputString = elem.value;
        this.specialKey = key_enter;
      }
    },
    /**
     * 長押しイベント開始
     *
     * @param String imgpath 画像パス
     */
    onTouchStart: function(imgpath) {
      this.log("TDic start TouchEvent::" + imgpath);
      if (this.isEnvironmentPc()) {
        // PCの場合は表示しない
        return;
      }
      var self = this;

      this.touchTimer = setTimeout(function() {
        self.showPinchInImage(imgpath);
      }, mixinConstants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      this.log("TDic end TouchEvent");
      clearTimeout(this.touchTimer);
    }
  },
  created() {
    this.log("TDic:created");
    this.log("lessonState: " + this.$store.getters.lessonState);
    this.init();
  },
  mounted() {
    this.log("TDic:mounted");
    this.setCards2();

    // 自動調整初期処理
    this.initAutoAdjustTyping();
  },
  beforeDestroy: function() {
    this.log("------ beforeDestroy ------");
    document.removeEventListener("keydown", this.keyDownFunc);
    if (this.r_timer != null) {
      clearTimeout(this.r_timer);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";

.answer {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #000000;
  letter-spacing: 0.04rem;
}
</style>



// WEBPACK FOOTER //
// TDic.vue?7bca7b40